import {
  Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip,
} from 'recharts';
import {
  PAID_DUE_PIE_COLORS,
  CHART_TOOLTIP_WRAPPER_PROPS,
  DashboardAmountTooltip,
} from './chartTheme.js';

const DashboardPieChart = ({
  title,
  rows = [],
  format = 'currency',
  emptyLabel,
  labelMap = {},
}) => {
  const data = (rows || [])
    .map((row) => ({
      key: row.key,
      name: labelMap[row.key] || row.name || row.label || row.key,
      value: Number(row.amount ?? row.value) || 0,
    }))
    .filter((row) => row.value > 0);

  return (
    <div>
      {title ? <p className="text-sm font-semibold text-gray-700 mb-2">{title}</p> : null}
      {data.length === 0 ? (
        <p className="text-sm text-gray-400 text-center py-10">{emptyLabel || 'No data'}</p>
      ) : (
        <div className="h-[200px] md:h-[260px] w-full">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie data={data} dataKey="value" nameKey="name" innerRadius={48} outerRadius={78}>
                {data.map((row) => (
                  <Cell key={row.key} fill={PAID_DUE_PIE_COLORS[row.key] || '#94a3b8'} />
                ))}
              </Pie>
              <Tooltip
                {...CHART_TOOLTIP_WRAPPER_PROPS}
                content={<DashboardAmountTooltip format={format} />}
              />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
};

export default DashboardPieChart;
